
/* !!! This is code generated by Prisma. Do not edit directly. !!! */
/* eslint-disable */
// biome-ignore-all lint: generated file
// @ts-nocheck 
/*
 * WARNING: This is an internal file that is subject to change!
 *
 * 🛑 Under no circumstances should you import this file directly! 🛑
 *
 * All exports from this file are wrapped under a `Prisma` namespace object in the browser.ts file.
 * While this enables partial backward compatibility, it is not part of the stable public API.
 *
 * If you are looking for your Models, Enums, and Input Types, please import them from the respective
 * model files in the `model` directory!
 */

import * as runtime from "@prisma/client/runtime/index-browser"

export type * from '../models'
export type * from './prismaNamespace'

export const Decimal = runtime.Decimal


export const NullTypes = {
  DbNull: runtime.NullTypes.DbNull as (new (secret: never) => typeof runtime.DbNull),
  JsonNull: runtime.NullTypes.JsonNull as (new (secret: never) => typeof runtime.JsonNull),
  AnyNull: runtime.NullTypes.AnyNull as (new (secret: never) => typeof runtime.AnyNull),
}
/**
 * Helper for filtering JSON entries that have `null` on the database (empty on the db)
 *
 * @see https://www.prisma.io/docs/concepts/components/prisma-client/working-with-fields/working-with-json-fields#filtering-on-a-json-field
 */
export const DbNull = runtime.DbNull

/**
 * Helper for filtering JSON entries that have JSON `null` values (not empty on the db)
 *
 * @see https://www.prisma.io/docs/concepts/components/prisma-client/working-with-fields/working-with-json-fields#filtering-on-a-json-field
 */
export const JsonNull = runtime.JsonNull

/**
 * Helper for filtering JSON entries that are `Prisma.DbNull` or `Prisma.JsonNull`
 *
 * @see https://www.prisma.io/docs/concepts/components/prisma-client/working-with-fields/working-with-json-fields#filtering-on-a-json-field
 */
export const AnyNull = runtime.AnyNull


export const ModelName = {
  User: 'User',
  UserMfaSettings: 'UserMfaSettings',
  AvaturnUser: 'AvaturnUser',
  UserWallet: 'UserWallet',
  WalletChallenge: 'WalletChallenge',
  PlayerTier: 'PlayerTier',
  TableTemplate: 'TableTemplate',
  RakeStructure: 'RakeStructure',
  Table: 'Table',
  Seat: 'Seat',
  Waitlist: 'Waitlist',
  Kyc: 'Kyc',
  Sumsub: 'Sumsub',
  Session: 'Session',
  PropSession: 'PropSession',
  CollectedRake: 'CollectedRake',
  GeneratedRake: 'GeneratedRake',
  GeneratedRakeAggregate: 'GeneratedRakeAggregate',
  GeneratedLeaderboardRakeAggregate: 'GeneratedLeaderboardRakeAggregate',
  DeckResult: 'DeckResult',
  MutedPlayer: 'MutedPlayer',
  Chat: 'Chat',
  TableSettings: 'TableSettings',
  UserLobbyFilters: 'UserLobbyFilters',
  PlayerDisconnection: 'PlayerDisconnection',
  DeviceFingerprint: 'DeviceFingerprint',
  RakeSharePayout: 'RakeSharePayout',
  RakeSharePayoutAggregate: 'RakeSharePayoutAggregate',
  RewardPayout: 'RewardPayout',
  UserAgreement: 'UserAgreement',
  PlayerMute: 'PlayerMute',
  PlayerBlock: 'PlayerBlock',
  RakebackPayout: 'RakebackPayout',
  Transaction: 'Transaction',
  HandHistory: 'HandHistory',
  HandStateHistory: 'HandStateHistory',
  FriendRequest: 'FriendRequest',
  Friend: 'Friend',
  PlayerProfile: 'PlayerProfile',
  Note: 'Note',
  InternalTokensDeals: 'InternalTokensDeals',
  DepositWallets: 'DepositWallets',
  Deposits: 'Deposits',
  DepositBonus: 'DepositBonus',
  UserDepositBonus: 'UserDepositBonus',
  PerformanceMetric: 'PerformanceMetric',
  WeeklyRakeSharePayout: 'WeeklyRakeSharePayout',
  WeeklyRakeStats: 'WeeklyRakeStats',
  Leaderboard: 'Leaderboard',
  LeaderboardHistory: 'LeaderboardHistory',
  LeaderboardSchedule: 'LeaderboardSchedule',
  ReferralHistory: 'ReferralHistory',
  ReferralHistoryMigration: 'ReferralHistoryMigration',
  Region: 'Region',
  Country: 'Country',
  CountrySubdivision: 'CountrySubdivision',
  AgentDeal: 'AgentDeal',
  RegionCountry: 'RegionCountry',
  RegionSubdivision: 'RegionSubdivision',
  AgentDealUpdateRequest: 'AgentDealUpdateRequest',
  AgentAssociationMigrationBatch: 'AgentAssociationMigrationBatch',
  AgentAssociationMigrationUser: 'AgentAssociationMigrationUser',
  ReferralRakeShareAggregate: 'ReferralRakeShareAggregate',
  ReferralRakeShareMigration: 'ReferralRakeShareMigration',
  TournamentTicketTemplate: 'TournamentTicketTemplate',
  TournamentTicket: 'TournamentTicket',
  TournamentBlindStructure: 'TournamentBlindStructure',
  TournamentBlindLevel: 'TournamentBlindLevel',
  TournamentPayoutStructure: 'TournamentPayoutStructure',
  TournamentPayoutBracket: 'TournamentPayoutBracket',
  TournamentBlindStructureSnapshot: 'TournamentBlindStructureSnapshot',
  TournamentBlindLevelSnapshot: 'TournamentBlindLevelSnapshot',
  TournamentPayoutStructureSnapshot: 'TournamentPayoutStructureSnapshot',
  TournamentPayoutBracketSnapshot: 'TournamentPayoutBracketSnapshot',
  TournamentTemplate: 'TournamentTemplate',
  TournamentRecurringSchedule: 'TournamentRecurringSchedule',
  Tournament: 'Tournament',
  TournamentRegistration: 'TournamentRegistration',
  TournamentTableAssignment: 'TournamentTableAssignment',
  TournamentEvent: 'TournamentEvent',
  TournamentRebuyAddonLog: 'TournamentRebuyAddonLog',
  TournamentPlayerMovement: 'TournamentPlayerMovement',
  TournamentPayout: 'TournamentPayout',
  TournamentDollarLedger: 'TournamentDollarLedger',
  TournamentRebalanceMetrics: 'TournamentRebalanceMetrics',
  GlobalSettings: 'GlobalSettings',
  TournamentSettings: 'TournamentSettings'
} as const

export type ModelName = (typeof ModelName)[keyof typeof ModelName]

/*
 * Enums
 */

export const TransactionIsolationLevel = {
  ReadUncommitted: 'ReadUncommitted',
  ReadCommitted: 'ReadCommitted',
  RepeatableRead: 'RepeatableRead',
  Serializable: 'Serializable'
} as const

export type TransactionIsolationLevel = (typeof TransactionIsolationLevel)[keyof typeof TransactionIsolationLevel]


export const UserScalarFieldEnum = {
  id: 'id',
  email: 'email',
  firstName: 'firstName',
  lastName: 'lastName',
  phone: 'phone',
  dialingCode: 'dialingCode',
  countryCode: 'countryCode',
  alias: 'alias',
  tierId: 'tierId',
  privyId: 'privyId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  hasAcceptedGreeting: 'hasAcceptedGreeting',
  banned: 'banned',
  locked: 'locked',
  refundBalance: 'refundBalance',
  tournamentDollars: 'tournamentDollars',
  referrerCode: 'referrerCode',
  referralDepth: 'referralDepth',
  referralCode: 'referralCode',
  isReferralQualified: 'isReferralQualified',
  referralQualificationDate: 'referralQualificationDate',
  referralRewardsAgreementId: 'referralRewardsAgreementId',
  referralProcessed: 'referralProcessed',
  phnmPayoutPercentage: 'phnmPayoutPercentage',
  isAgent: 'isAgent',
  isAmbassador: 'isAmbassador',
  isPropPlayer: 'isPropPlayer',
  isStreamer: 'isStreamer',
  privacyModeEnabled: 'privacyModeEnabled',
  streamingNow: 'streamingNow',
  streamName: 'streamName',
  streamUrl: 'streamUrl',
  ambassadorSince: 'ambassadorSince',
  agentSince: 'agentSince',
  smartWalletAddress: 'smartWalletAddress',
  mainWalletAddress: 'mainWalletAddress',
  visitorId: 'visitorId',
  tierAchievedAt: 'tierAchievedAt',
  tierExpiresAt: 'tierExpiresAt',
  utmSource: 'utmSource',
  utmMedium: 'utmMedium',
  utmCampaign: 'utmCampaign',
  utmTerm: 'utmTerm',
  utmContent: 'utmContent',
  gclid: 'gclid',
  fbclid: 'fbclid',
  clickId: 'clickId',
  referrer: 'referrer',
  referralLandingUrl: 'referralLandingUrl',
  blockchainAdsNotified: 'blockchainAdsNotified',
  deposited: 'deposited',
  adminNotes: 'adminNotes',
  role: 'role'
} as const

export type UserScalarFieldEnum = (typeof UserScalarFieldEnum)[keyof typeof UserScalarFieldEnum]


export const UserMfaSettingsScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  exemptPHNMRedeem: 'exemptPHNMRedeem',
  exemptReferralTransfer: 'exemptReferralTransfer',
  exemptFriendTransfer: 'exemptFriendTransfer',
  exemptAnyTransfer: 'exemptAnyTransfer',
  exemptTournamentRegistration: 'exemptTournamentRegistration',
  otpEnabled: 'otpEnabled',
  otpSecret: 'otpSecret',
  otpLastUsedAt: 'otpLastUsedAt',
  otpFailedAttempts: 'otpFailedAttempts',
  otpLockedUntil: 'otpLockedUntil',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type UserMfaSettingsScalarFieldEnum = (typeof UserMfaSettingsScalarFieldEnum)[keyof typeof UserMfaSettingsScalarFieldEnum]


export const AvaturnUserScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  avatarId: 'avatarId',
  modelUrl: 'modelUrl',
  imageUrl: 'imageUrl'
} as const

export type AvaturnUserScalarFieldEnum = (typeof AvaturnUserScalarFieldEnum)[keyof typeof AvaturnUserScalarFieldEnum]


export const UserWalletScalarFieldEnum = {
  id: 'id',
  address: 'address',
  userId: 'userId',
  label: 'label',
  primary: 'primary',
  createdAt: 'createdAt',
  igr: 'igr'
} as const

export type UserWalletScalarFieldEnum = (typeof UserWalletScalarFieldEnum)[keyof typeof UserWalletScalarFieldEnum]


export const WalletChallengeScalarFieldEnum = {
  userId: 'userId',
  challenge: 'challenge',
  expiration: 'expiration',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type WalletChallengeScalarFieldEnum = (typeof WalletChallengeScalarFieldEnum)[keyof typeof WalletChallengeScalarFieldEnum]


export const PlayerTierScalarFieldEnum = {
  id: 'id',
  name: 'name',
  tier: 'tier',
  rakeback: 'rakeback',
  discount: 'discount',
  description: 'description',
  rakeRequired: 'rakeRequired',
  validForInDays: 'validForInDays'
} as const

export type PlayerTierScalarFieldEnum = (typeof PlayerTierScalarFieldEnum)[keyof typeof PlayerTierScalarFieldEnum]


export const TableTemplateScalarFieldEnum = {
  id: 'id',
  name: 'name',
  game: 'game',
  variants: 'variants',
  maxPlayers: 'maxPlayers',
  minBuyin: 'minBuyin',
  maxBuyin: 'maxBuyin',
  category: 'category',
  bettingStructure: 'bettingStructure',
  ante: 'ante',
  bringIn: 'bringIn',
  smallBlind: 'smallBlind',
  bigBlind: 'bigBlind',
  smallBet: 'smallBet',
  bigBet: 'bigBet',
  minStake: 'minStake',
  maxStake: 'maxStake',
  bettingCap: 'bettingCap',
  isPublic: 'isPublic',
  lobbyIcons: 'lobbyIcons',
  rakeStructureId: 'rakeStructureId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type TableTemplateScalarFieldEnum = (typeof TableTemplateScalarFieldEnum)[keyof typeof TableTemplateScalarFieldEnum]


export const RakeStructureScalarFieldEnum = {
  id: 'id',
  blinds: 'blinds',
  bettingStructure: 'bettingStructure',
  points: 'points',
  rakePercent: 'rakePercent',
  rakeCap: 'rakeCap',
  rakeCapHU: 'rakeCapHU'
} as const

export type RakeStructureScalarFieldEnum = (typeof RakeStructureScalarFieldEnum)[keyof typeof RakeStructureScalarFieldEnum]


export const TableScalarFieldEnum = {
  id: 'id',
  type: 'type',
  tableTemplateId: 'tableTemplateId',
  name: 'name',
  game: 'game',
  category: 'category',
  bettingStructure: 'bettingStructure',
  variants: 'variants',
  maxPlayers: 'maxPlayers',
  ante: 'ante',
  smallBlind: 'smallBlind',
  bigBlind: 'bigBlind',
  bringIn: 'bringIn',
  smallBet: 'smallBet',
  bigBet: 'bigBet',
  minBuyin: 'minBuyin',
  maxBuyin: 'maxBuyin',
  bettingCap: 'bettingCap',
  rakePercent: 'rakePercent',
  rakeCap: 'rakeCap',
  rakeCapHU: 'rakeCapHU',
  minStake: 'minStake',
  maxStake: 'maxStake',
  timeoutInSeconds: 'timeoutInSeconds',
  dealerSeat: 'dealerSeat',
  contractId: 'contractId',
  contractAddress: 'contractAddress',
  contractHistory: 'contractHistory',
  isRealMoney: 'isRealMoney',
  isPublic: 'isPublic',
  status: 'status',
  tableNumber: 'tableNumber',
  lobbyIcons: 'lobbyIcons',
  avgPot: 'avgPot',
  handsDealt: 'handsDealt',
  handsPerGame: 'handsPerGame',
  url: 'url',
  queueUrl: 'queueUrl',
  topicArn: 'topicArn',
  tournamentId: 'tournamentId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt'
} as const

export type TableScalarFieldEnum = (typeof TableScalarFieldEnum)[keyof typeof TableScalarFieldEnum]


export const SeatScalarFieldEnum = {
  userId: 'userId',
  tableId: 'tableId',
  seat: 'seat',
  stack: 'stack',
  extraStack: 'extraStack',
  createdAt: 'createdAt',
  playerIndex: 'playerIndex',
  active: 'active',
  lastActiveAt: 'lastActiveAt',
  waiting: 'waiting',
  autoTopStack: 'autoTopStack',
  autoTopUpBuyIn: 'autoTopUpBuyIn',
  autoTopUpThreshold: 'autoTopUpThreshold',
  autoTopUpToTableMax: 'autoTopUpToTableMax',
  autoTopBalance: 'autoTopBalance',
  buyIn: 'buyIn',
  skippedSB: 'skippedSB',
  skippedBB: 'skippedBB',
  timebank: 'timebank',
  disconnectionTimebank: 'disconnectionTimebank',
  handsDealt: 'handsDealt',
  handsWithNoStackCount: 'handsWithNoStackCount'
} as const

export type SeatScalarFieldEnum = (typeof SeatScalarFieldEnum)[keyof typeof SeatScalarFieldEnum]


export const WaitlistScalarFieldEnum = {
  userId: 'userId',
  tableId: 'tableId',
  createdAt: 'createdAt',
  attemptJoiningAt: 'attemptJoiningAt'
} as const

export type WaitlistScalarFieldEnum = (typeof WaitlistScalarFieldEnum)[keyof typeof WaitlistScalarFieldEnum]


export const KycScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  approved: 'approved',
  userId: 'userId'
} as const

export type KycScalarFieldEnum = (typeof KycScalarFieldEnum)[keyof typeof KycScalarFieldEnum]


export const SumsubScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  accessToken: 'accessToken',
  status: 'status',
  kycId: 'kycId'
} as const

export type SumsubScalarFieldEnum = (typeof SumsubScalarFieldEnum)[keyof typeof SumsubScalarFieldEnum]


export const SessionScalarFieldEnum = {
  id: 'id',
  tableId: 'tableId',
  userId: 'userId',
  createdAt: 'createdAt',
  closedAt: 'closedAt',
  stack: 'stack',
  timebank: 'timebank',
  disconnectionTimebank: 'disconnectionTimebank',
  handsDealt: 'handsDealt'
} as const

export type SessionScalarFieldEnum = (typeof SessionScalarFieldEnum)[keyof typeof SessionScalarFieldEnum]


export const PropSessionScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  tableId: 'tableId',
  sessionId: 'sessionId',
  startTime: 'startTime',
  endTime: 'endTime',
  minutesPlayed: 'minutesPlayed',
  hourlyRate: 'hourlyRate'
} as const

export type PropSessionScalarFieldEnum = (typeof PropSessionScalarFieldEnum)[keyof typeof PropSessionScalarFieldEnum]


export const CollectedRakeScalarFieldEnum = {
  handId: 'handId',
  tableId: 'tableId',
  tournamentId: 'tournamentId',
  amount: 'amount',
  collected: 'collected',
  createdAt: 'createdAt'
} as const

export type CollectedRakeScalarFieldEnum = (typeof CollectedRakeScalarFieldEnum)[keyof typeof CollectedRakeScalarFieldEnum]


export const GeneratedRakeScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  handId: 'handId',
  tableId: 'tableId',
  tournamentId: 'tournamentId',
  amount: 'amount',
  createdAt: 'createdAt',
  aggregated: 'aggregated',
  aggregatedForLeaderboard: 'aggregatedForLeaderboard',
  isHeadsUp: 'isHeadsUp'
} as const

export type GeneratedRakeScalarFieldEnum = (typeof GeneratedRakeScalarFieldEnum)[keyof typeof GeneratedRakeScalarFieldEnum]


export const GeneratedRakeAggregateScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  amount: 'amount',
  amountNonHU: 'amountNonHU',
  count: 'count',
  startDate: 'startDate',
  endDate: 'endDate',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type GeneratedRakeAggregateScalarFieldEnum = (typeof GeneratedRakeAggregateScalarFieldEnum)[keyof typeof GeneratedRakeAggregateScalarFieldEnum]


export const GeneratedLeaderboardRakeAggregateScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  leaderboardId: 'leaderboardId',
  amount: 'amount',
  amountNonHU: 'amountNonHU',
  count: 'count',
  countNonHU: 'countNonHU',
  startDate: 'startDate',
  endDate: 'endDate',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type GeneratedLeaderboardRakeAggregateScalarFieldEnum = (typeof GeneratedLeaderboardRakeAggregateScalarFieldEnum)[keyof typeof GeneratedLeaderboardRakeAggregateScalarFieldEnum]


export const DeckResultScalarFieldEnum = {
  handId: 'handId',
  tableId: 'tableId',
  deck: 'deck',
  valid: 'valid'
} as const

export type DeckResultScalarFieldEnum = (typeof DeckResultScalarFieldEnum)[keyof typeof DeckResultScalarFieldEnum]


export const MutedPlayerScalarFieldEnum = {
  tableId: 'tableId',
  userId: 'userId',
  mutedUserIds: 'mutedUserIds'
} as const

export type MutedPlayerScalarFieldEnum = (typeof MutedPlayerScalarFieldEnum)[keyof typeof MutedPlayerScalarFieldEnum]


export const ChatScalarFieldEnum = {
  id: 'id',
  tableId: 'tableId',
  userId: 'userId',
  message: 'message',
  isPlayer: 'isPlayer',
  createdAt: 'createdAt'
} as const

export type ChatScalarFieldEnum = (typeof ChatScalarFieldEnum)[keyof typeof ChatScalarFieldEnum]


export const TableSettingsScalarFieldEnum = {
  userId: 'userId',
  feltColor: 'feltColor',
  backgroundDesign: 'backgroundDesign',
  deckDesign: 'deckDesign',
  deckBackDesign: 'deckBackDesign',
  tableTabsInDesktopEnabled: 'tableTabsInDesktopEnabled',
  currentHandValueEnabled: 'currentHandValueEnabled',
  autoTimeBankEnabled: 'autoTimeBankEnabled',
  runItTwiceEnabled: 'runItTwiceEnabled',
  runItMultipleEnabled: 'runItMultipleEnabled',
  runItMultiplePreference: 'runItMultiplePreference',
  stackInBigBlindsEnabled: 'stackInBigBlindsEnabled',
  chipsInBigBlindsEnabled: 'chipsInBigBlindsEnabled',
  animationsEnabled: 'animationsEnabled',
  autoMuckCardsEnabled: 'autoMuckCardsEnabled',
  displayFoldedCardsEnabled: 'displayFoldedCardsEnabled',
  allInEquityValueEnabled: 'allInEquityValueEnabled',
  tierFrameEnabled: 'tierFrameEnabled',
  showHandStrengthEnabled: 'showHandStrengthEnabled',
  modelsEnabled: 'modelsEnabled',
  showRealNameEnabled: 'showRealNameEnabled',
  fannedCardsDisplayEnabled: 'fannedCardsDisplayEnabled',
  autoSortCardsEnabled: 'autoSortCardsEnabled',
  chatBubblesEnabled: 'chatBubblesEnabled',
  soundEnabled: 'soundEnabled',
  soundVolumes: 'soundVolumes',
  stepInBigBlindsEnabled: 'stepInBigBlindsEnabled',
  hotkeys: 'hotkeys',
  buttonConfigurations: 'buttonConfigurations'
} as const

export type TableSettingsScalarFieldEnum = (typeof TableSettingsScalarFieldEnum)[keyof typeof TableSettingsScalarFieldEnum]


export const UserLobbyFiltersScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  tableType: 'tableType',
  category: 'category',
  games: 'games',
  fullTables: 'fullTables',
  emptyTables: 'emptyTables',
  huTables: 'huTables',
  minBuyIn: 'minBuyIn',
  maxBuyIn: 'maxBuyIn',
  maxPlayers: 'maxPlayers',
  stakeOptions: 'stakeOptions',
  gameTypes: 'gameTypes',
  sorting: 'sorting',
  lobbyIcons: 'lobbyIcons'
} as const

export type UserLobbyFiltersScalarFieldEnum = (typeof UserLobbyFiltersScalarFieldEnum)[keyof typeof UserLobbyFiltersScalarFieldEnum]


export const PlayerDisconnectionScalarFieldEnum = {
  id: 'id',
  tableId: 'tableId',
  userId: 'userId',
  handId: 'handId',
  disconnectedAt: 'disconnectedAt'
} as const

export type PlayerDisconnectionScalarFieldEnum = (typeof PlayerDisconnectionScalarFieldEnum)[keyof typeof PlayerDisconnectionScalarFieldEnum]


export const DeviceFingerprintScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  requestId: 'requestId',
  visitorId: 'visitorId',
  ipAddress: 'ipAddress',
  country: 'country',
  city: 'city',
  isVpn: 'isVpn',
  browserName: 'browserName',
  browserFullVersion: 'browserFullVersion',
  os: 'os',
  osVersion: 'osVersion',
  device: 'device',
  createdAt: 'createdAt'
} as const

export type DeviceFingerprintScalarFieldEnum = (typeof DeviceFingerprintScalarFieldEnum)[keyof typeof DeviceFingerprintScalarFieldEnum]


export const RakeSharePayoutScalarFieldEnum = {
  id: 'id',
  amount: 'amount',
  strategy: 'strategy',
  userId: 'userId',
  createdAt: 'createdAt',
  generatedRakeId: 'generatedRakeId',
  referralId: 'referralId',
  referrerId: 'referrerId',
  sourcePayoutId: 'sourcePayoutId',
  paid: 'paid',
  rakeShareType: 'rakeShareType',
  transactionId: 'transactionId',
  aggregated: 'aggregated'
} as const

export type RakeSharePayoutScalarFieldEnum = (typeof RakeSharePayoutScalarFieldEnum)[keyof typeof RakeSharePayoutScalarFieldEnum]


export const RakeSharePayoutAggregateScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  amount: 'amount',
  count: 'count',
  startDate: 'startDate',
  endDate: 'endDate',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type RakeSharePayoutAggregateScalarFieldEnum = (typeof RakeSharePayoutAggregateScalarFieldEnum)[keyof typeof RakeSharePayoutAggregateScalarFieldEnum]


export const RewardPayoutScalarFieldEnum = {
  id: 'id',
  amount: 'amount',
  strategy: 'strategy',
  userId: 'userId',
  paid: 'paid',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  rewardType: 'rewardType',
  referralId: 'referralId',
  referrerId: 'referrerId',
  sourcePayoutId: 'sourcePayoutId',
  transactionId: 'transactionId'
} as const

export type RewardPayoutScalarFieldEnum = (typeof RewardPayoutScalarFieldEnum)[keyof typeof RewardPayoutScalarFieldEnum]


export const UserAgreementScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  agreement: 'agreement',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  qualifiedReferralsCount: 'qualifiedReferralsCount',
  isActive: 'isActive'
} as const

export type UserAgreementScalarFieldEnum = (typeof UserAgreementScalarFieldEnum)[keyof typeof UserAgreementScalarFieldEnum]


export const PlayerMuteScalarFieldEnum = {
  userId: 'userId',
  mutedId: 'mutedId'
} as const

export type PlayerMuteScalarFieldEnum = (typeof PlayerMuteScalarFieldEnum)[keyof typeof PlayerMuteScalarFieldEnum]


export const PlayerBlockScalarFieldEnum = {
  userId: 'userId',
  blockedId: 'blockedId'
} as const

export type PlayerBlockScalarFieldEnum = (typeof PlayerBlockScalarFieldEnum)[keyof typeof PlayerBlockScalarFieldEnum]


export const RakebackPayoutScalarFieldEnum = {
  id: 'id',
  amount: 'amount',
  paid: 'paid',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  userId: 'userId',
  rakeId: 'rakeId',
  transactionId: 'transactionId'
} as const

export type RakebackPayoutScalarFieldEnum = (typeof RakebackPayoutScalarFieldEnum)[keyof typeof RakebackPayoutScalarFieldEnum]


export const TransactionScalarFieldEnum = {
  id: 'id',
  status: 'status',
  type: 'type',
  txId: 'txId',
  userId: 'userId',
  tableId: 'tableId',
  tournamentId: 'tournamentId',
  ticketId: 'ticketId',
  tournamentContractId: 'tournamentContractId',
  contractTableId: 'contractTableId',
  contractTableAddress: 'contractTableAddress',
  params: 'params',
  receipt: 'receipt',
  txCallData: 'txCallData',
  amount: 'amount',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  message: 'message',
  from: 'from',
  to: 'to',
  newBalanceFrom: 'newBalanceFrom',
  newBalanceTo: 'newBalanceTo',
  addressFrom: 'addressFrom',
  addressTo: 'addressTo',
  currency: 'currency',
  chain: 'chain',
  failedReason: 'failedReason',
  retries: 'retries'
} as const

export type TransactionScalarFieldEnum = (typeof TransactionScalarFieldEnum)[keyof typeof TransactionScalarFieldEnum]


export const HandHistoryScalarFieldEnum = {
  id: 'id',
  tableId: 'tableId',
  handId: 'handId',
  userId: 'userId',
  cards: 'cards',
  mappings: 'mappings',
  alias: 'alias',
  result: 'result',
  stackImbalance: 'stackImbalance',
  createdAt: 'createdAt'
} as const

export type HandHistoryScalarFieldEnum = (typeof HandHistoryScalarFieldEnum)[keyof typeof HandHistoryScalarFieldEnum]


export const HandStateHistoryScalarFieldEnum = {
  id: 'id',
  tableId: 'tableId',
  handId: 'handId',
  states: 'states',
  statesCompressed: 'statesCompressed',
  createdAt: 'createdAt'
} as const

export type HandStateHistoryScalarFieldEnum = (typeof HandStateHistoryScalarFieldEnum)[keyof typeof HandStateHistoryScalarFieldEnum]


export const FriendRequestScalarFieldEnum = {
  id: 'id',
  senderId: 'senderId',
  receiverId: 'receiverId',
  status: 'status',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type FriendRequestScalarFieldEnum = (typeof FriendRequestScalarFieldEnum)[keyof typeof FriendRequestScalarFieldEnum]


export const FriendScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  friendId: 'friendId',
  createdAt: 'createdAt'
} as const

export type FriendScalarFieldEnum = (typeof FriendScalarFieldEnum)[keyof typeof FriendScalarFieldEnum]


export const PlayerProfileScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  targetUserId: 'targetUserId',
  notesColor: 'notesColor'
} as const

export type PlayerProfileScalarFieldEnum = (typeof PlayerProfileScalarFieldEnum)[keyof typeof PlayerProfileScalarFieldEnum]


export const NoteScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  targetUserId: 'targetUserId',
  profileId: 'profileId',
  content: 'content',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type NoteScalarFieldEnum = (typeof NoteScalarFieldEnum)[keyof typeof NoteScalarFieldEnum]


export const InternalTokensDealsScalarFieldEnum = {
  id: 'id',
  index: 'index',
  walletAddress: 'walletAddress',
  originalAmount: 'originalAmount',
  remainingAmount: 'remainingAmount',
  startTime: 'startTime',
  endTime: 'endTime',
  vestingPeriod: 'vestingPeriod',
  lastUpdateTime: 'lastUpdateTime',
  isRevoked: 'isRevoked'
} as const

export type InternalTokensDealsScalarFieldEnum = (typeof InternalTokensDealsScalarFieldEnum)[keyof typeof InternalTokensDealsScalarFieldEnum]


export const DepositWalletsScalarFieldEnum = {
  id: 'id',
  fireblocksVaultAccountId: 'fireblocksVaultAccountId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type DepositWalletsScalarFieldEnum = (typeof DepositWalletsScalarFieldEnum)[keyof typeof DepositWalletsScalarFieldEnum]


export const DepositsScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  inboundTxId: 'inboundTxId',
  outboundTxId: 'outboundTxId',
  amount: 'amount',
  currency: 'currency',
  chain: 'chain',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type DepositsScalarFieldEnum = (typeof DepositsScalarFieldEnum)[keyof typeof DepositsScalarFieldEnum]


export const DepositBonusScalarFieldEnum = {
  id: 'id',
  name: 'name',
  description: 'description',
  longDescription: 'longDescription',
  active: 'active',
  createdAt: 'createdAt',
  maxBonus: 'maxBonus',
  bonusAmount: 'bonusAmount',
  incrementSize: 'incrementSize',
  qualifierType: 'qualifierType',
  qualifierMultiplier: 'qualifierMultiplier',
  bonusCode: 'bonusCode',
  imageUrl: 'imageUrl',
  eligibilityRules: 'eligibilityRules',
  validForInDays: 'validForInDays',
  referralCode: 'referralCode',
  startDate: 'startDate',
  endDate: 'endDate'
} as const

export type DepositBonusScalarFieldEnum = (typeof DepositBonusScalarFieldEnum)[keyof typeof DepositBonusScalarFieldEnum]


export const UserDepositBonusScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  depositBonusId: 'depositBonusId',
  currentDeposit: 'currentDeposit',
  targetAmount: 'targetAmount',
  bonusEarned: 'bonusEarned',
  totalLocked: 'totalLocked',
  isCompleted: 'isCompleted',
  status: 'status',
  depositedAt: 'depositedAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  expiresAt: 'expiresAt'
} as const

export type UserDepositBonusScalarFieldEnum = (typeof UserDepositBonusScalarFieldEnum)[keyof typeof UserDepositBonusScalarFieldEnum]


export const PerformanceMetricScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  timestamp: 'timestamp',
  url: 'url',
  deviceMemory: 'deviceMemory',
  maxMemory: 'maxMemory',
  allocatedMemory: 'allocatedMemory',
  usedMemory: 'usedMemory',
  pageLoad: 'pageLoad',
  domComplete: 'domComplete',
  domInteractive: 'domInteractive',
  resourceCount: 'resourceCount',
  totalResourceTime: 'totalResourceTime',
  firstPaint: 'firstPaint',
  firstContentfulPaint: 'firstContentfulPaint',
  hardwareConcurrency: 'hardwareConcurrency',
  frameRate: 'frameRate',
  taskLatency: 'taskLatency',
  browserName: 'browserName',
  browserVersion: 'browserVersion',
  engineName: 'engineName',
  platform: 'platform',
  deviceType: 'deviceType',
  screenWidth: 'screenWidth',
  screenHeight: 'screenHeight',
  screenPixelRatio: 'screenPixelRatio',
  connectionType: 'connectionType',
  downlink: 'downlink',
  rtt: 'rtt',
  saveData: 'saveData',
  onLine: 'onLine',
  webgl: 'webgl',
  createdAt: 'createdAt'
} as const

export type PerformanceMetricScalarFieldEnum = (typeof PerformanceMetricScalarFieldEnum)[keyof typeof PerformanceMetricScalarFieldEnum]


export const WeeklyRakeSharePayoutScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  agreementId: 'agreementId',
  weekRakeStatsId: 'weekRakeStatsId',
  total: 'total',
  directRakeShareAmount: 'directRakeShareAmount',
  downstreamRakeShareAmount: 'downstreamRakeShareAmount',
  totalDownlineRakeShare: 'totalDownlineRakeShare',
  weekStartDate: 'weekStartDate',
  weekEndDate: 'weekEndDate',
  processed: 'processed',
  usdtPaid: 'usdtPaid',
  phnmPaid: 'phnmPaid',
  usdtTransactionId: 'usdtTransactionId',
  phnmTransactionId: 'phnmTransactionId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type WeeklyRakeSharePayoutScalarFieldEnum = (typeof WeeklyRakeSharePayoutScalarFieldEnum)[keyof typeof WeeklyRakeSharePayoutScalarFieldEnum]


export const WeeklyRakeStatsScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  agreementId: 'agreementId',
  weekStartDate: 'weekStartDate',
  weekEndDate: 'weekEndDate',
  totalRake: 'totalRake',
  directRake: 'directRake',
  downlineRake: 'downlineRake',
  rakeSharePercentage: 'rakeSharePercentage',
  bonusPercentage: 'bonusPercentage',
  newQualifications: 'newQualifications',
  processed: 'processed',
  phnmPayoutPercentage: 'phnmPayoutPercentage',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type WeeklyRakeStatsScalarFieldEnum = (typeof WeeklyRakeStatsScalarFieldEnum)[keyof typeof WeeklyRakeStatsScalarFieldEnum]


export const LeaderboardScalarFieldEnum = {
  id: 'id',
  name: 'name',
  description: 'description',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  minReseedAmount: 'minReseedAmount',
  pointPerDollar: 'pointPerDollar',
  prizeTierStructure: 'prizeTierStructure',
  minRakeQualifierAmount: 'minRakeQualifierAmount',
  minBigBet: 'minBigBet',
  maxBigBet: 'maxBigBet',
  minBigBlind: 'minBigBlind',
  maxBigBlind: 'maxBigBlind',
  type: 'type',
  status: 'status',
  startDate: 'startDate',
  endDate: 'endDate',
  prizeWinners: 'prizeWinners',
  finalPrizePool: 'finalPrizePool',
  totalBalance: 'totalBalance',
  reseedAmount: 'reseedAmount',
  reseedPercentage: 'reseedPercentage'
} as const

export type LeaderboardScalarFieldEnum = (typeof LeaderboardScalarFieldEnum)[keyof typeof LeaderboardScalarFieldEnum]


export const LeaderboardHistoryScalarFieldEnum = {
  id: 'id',
  leaderboardId: 'leaderboardId',
  createdAt: 'createdAt',
  rankings: 'rankings'
} as const

export type LeaderboardHistoryScalarFieldEnum = (typeof LeaderboardHistoryScalarFieldEnum)[keyof typeof LeaderboardHistoryScalarFieldEnum]


export const LeaderboardScheduleScalarFieldEnum = {
  id: 'id',
  cronString: 'cronString',
  description: 'description',
  isActive: 'isActive',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  createdBy: 'createdBy'
} as const

export type LeaderboardScheduleScalarFieldEnum = (typeof LeaderboardScheduleScalarFieldEnum)[keyof typeof LeaderboardScheduleScalarFieldEnum]


export const ReferralHistoryScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  previousReferrerId: 'previousReferrerId',
  newReferrerId: 'newReferrerId',
  previousAgreementId: 'previousAgreementId',
  newAgreementId: 'newAgreementId',
  periodStart: 'periodStart',
  periodEnd: 'periodEnd',
  reason: 'reason',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type ReferralHistoryScalarFieldEnum = (typeof ReferralHistoryScalarFieldEnum)[keyof typeof ReferralHistoryScalarFieldEnum]


export const ReferralHistoryMigrationScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  status: 'status',
  normalizationStatus: 'normalizationStatus',
  normalizationAttemptCount: 'normalizationAttemptCount',
  normalizationLastAttemptAt: 'normalizationLastAttemptAt',
  normalizationLastError: 'normalizationLastError',
  lastAttemptAt: 'lastAttemptAt',
  attemptCount: 'attemptCount',
  lastError: 'lastError',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type ReferralHistoryMigrationScalarFieldEnum = (typeof ReferralHistoryMigrationScalarFieldEnum)[keyof typeof ReferralHistoryMigrationScalarFieldEnum]


export const RegionScalarFieldEnum = {
  id: 'id',
  name: 'name',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type RegionScalarFieldEnum = (typeof RegionScalarFieldEnum)[keyof typeof RegionScalarFieldEnum]


export const CountryScalarFieldEnum = {
  id: 'id',
  name: 'name',
  code: 'code',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type CountryScalarFieldEnum = (typeof CountryScalarFieldEnum)[keyof typeof CountryScalarFieldEnum]


export const CountrySubdivisionScalarFieldEnum = {
  id: 'id',
  name: 'name',
  code: 'code',
  countryId: 'countryId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type CountrySubdivisionScalarFieldEnum = (typeof CountrySubdivisionScalarFieldEnum)[keyof typeof CountrySubdivisionScalarFieldEnum]


export const AgentDealScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  agreementId: 'agreementId',
  dealType: 'dealType',
  rakeSharePercentage: 'rakeSharePercentage',
  flatFee: 'flatFee',
  bonus: 'bonus',
  startDate: 'startDate',
  endDate: 'endDate',
  pendingActivation: 'pendingActivation',
  isRegionalManager: 'isRegionalManager',
  automaticDownlineInheritance: 'automaticDownlineInheritance',
  completeUserVisibility: 'completeUserVisibility',
  regionId: 'regionId',
  canCreateSubAgents: 'canCreateSubAgents',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt'
} as const

export type AgentDealScalarFieldEnum = (typeof AgentDealScalarFieldEnum)[keyof typeof AgentDealScalarFieldEnum]


export const RegionCountryScalarFieldEnum = {
  regionId: 'regionId',
  countryId: 'countryId',
  createdAt: 'createdAt'
} as const

export type RegionCountryScalarFieldEnum = (typeof RegionCountryScalarFieldEnum)[keyof typeof RegionCountryScalarFieldEnum]


export const RegionSubdivisionScalarFieldEnum = {
  regionId: 'regionId',
  subdivisionId: 'subdivisionId',
  createdAt: 'createdAt'
} as const

export type RegionSubdivisionScalarFieldEnum = (typeof RegionSubdivisionScalarFieldEnum)[keyof typeof RegionSubdivisionScalarFieldEnum]


export const AgentDealUpdateRequestScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  agentDealId: 'agentDealId',
  applied: 'applied',
  createdBy: 'createdBy',
  currentCycle: 'currentCycle',
  validFrom: 'validFrom',
  currentPercentage: 'currentPercentage',
  newPercentage: 'newPercentage',
  hasPercentageConflict: 'hasPercentageConflict',
  conflictMessage: 'conflictMessage',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type AgentDealUpdateRequestScalarFieldEnum = (typeof AgentDealUpdateRequestScalarFieldEnum)[keyof typeof AgentDealUpdateRequestScalarFieldEnum]


export const AgentAssociationMigrationBatchScalarFieldEnum = {
  id: 'id',
  createdByUserId: 'createdByUserId',
  sourceAgentId: 'sourceAgentId',
  destinationAgentId: 'destinationAgentId',
  effectiveFrom: 'effectiveFrom',
  status: 'status',
  processedAt: 'processedAt',
  error: 'error',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type AgentAssociationMigrationBatchScalarFieldEnum = (typeof AgentAssociationMigrationBatchScalarFieldEnum)[keyof typeof AgentAssociationMigrationBatchScalarFieldEnum]


export const AgentAssociationMigrationUserScalarFieldEnum = {
  id: 'id',
  batchId: 'batchId',
  userId: 'userId',
  status: 'status',
  processedAt: 'processedAt',
  error: 'error',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type AgentAssociationMigrationUserScalarFieldEnum = (typeof AgentAssociationMigrationUserScalarFieldEnum)[keyof typeof AgentAssociationMigrationUserScalarFieldEnum]


export const ReferralRakeShareAggregateScalarFieldEnum = {
  id: 'id',
  referralId: 'referralId',
  referrerId: 'referrerId',
  agreementId: 'agreementId',
  totalRakeGenerated: 'totalRakeGenerated',
  totalRakeShare: 'totalRakeShare',
  directRakeShare: 'directRakeShare',
  upstreamRakeShare: 'upstreamRakeShare',
  weekStartDate: 'weekStartDate',
  weekEndDate: 'weekEndDate',
  isCurrentWeek: 'isCurrentWeek',
  agreementType: 'agreementType',
  rakeSharePercentage: 'rakeSharePercentage',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type ReferralRakeShareAggregateScalarFieldEnum = (typeof ReferralRakeShareAggregateScalarFieldEnum)[keyof typeof ReferralRakeShareAggregateScalarFieldEnum]


export const ReferralRakeShareMigrationScalarFieldEnum = {
  id: 'id',
  referrerId: 'referrerId',
  referralId: 'referralId',
  agreementId: 'agreementId',
  startDate: 'startDate',
  endDate: 'endDate',
  status: 'status',
  attempts: 'attempts',
  lastError: 'lastError',
  processedAt: 'processedAt',
  checksum: 'checksum',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type ReferralRakeShareMigrationScalarFieldEnum = (typeof ReferralRakeShareMigrationScalarFieldEnum)[keyof typeof ReferralRakeShareMigrationScalarFieldEnum]


export const TournamentTicketTemplateScalarFieldEnum = {
  id: 'id',
  name: 'name',
  description: 'description',
  type: 'type',
  tournamentId: 'tournamentId',
  templateId: 'templateId',
  value: 'value',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type TournamentTicketTemplateScalarFieldEnum = (typeof TournamentTicketTemplateScalarFieldEnum)[keyof typeof TournamentTicketTemplateScalarFieldEnum]


export const TournamentTicketScalarFieldEnum = {
  id: 'id',
  displayName: 'displayName',
  userId: 'userId',
  type: 'type',
  value: 'value',
  tournamentPayoutId: 'tournamentPayoutId',
  templateId: 'templateId',
  tournamentId: 'tournamentId',
  tournamentRegistrationId: 'tournamentRegistrationId',
  originTransactionId: 'originTransactionId',
  used: 'used',
  status: 'status',
  usedAt: 'usedAt',
  expiresAt: 'expiresAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type TournamentTicketScalarFieldEnum = (typeof TournamentTicketScalarFieldEnum)[keyof typeof TournamentTicketScalarFieldEnum]


export const TournamentBlindStructureScalarFieldEnum = {
  id: 'id',
  name: 'name',
  description: 'description',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type TournamentBlindStructureScalarFieldEnum = (typeof TournamentBlindStructureScalarFieldEnum)[keyof typeof TournamentBlindStructureScalarFieldEnum]


export const TournamentBlindLevelScalarFieldEnum = {
  blindStructureId: 'blindStructureId',
  levelNumber: 'levelNumber',
  ante: 'ante',
  smallBlind: 'smallBlind',
  bigBlind: 'bigBlind',
  bringIn: 'bringIn',
  smallBet: 'smallBet',
  bigBet: 'bigBet'
} as const

export type TournamentBlindLevelScalarFieldEnum = (typeof TournamentBlindLevelScalarFieldEnum)[keyof typeof TournamentBlindLevelScalarFieldEnum]


export const TournamentPayoutStructureScalarFieldEnum = {
  id: 'id',
  name: 'name',
  description: 'description',
  type: 'type',
  active: 'active',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type TournamentPayoutStructureScalarFieldEnum = (typeof TournamentPayoutStructureScalarFieldEnum)[keyof typeof TournamentPayoutStructureScalarFieldEnum]


export const TournamentPayoutBracketScalarFieldEnum = {
  id: 'id',
  payoutStructureId: 'payoutStructureId',
  playersFrom: 'playersFrom',
  playersTo: 'playersTo',
  rankFrom: 'rankFrom',
  rankTo: 'rankTo',
  percentage: 'percentage',
  ticketTemplateId: 'ticketTemplateId',
  ticketQuantity: 'ticketQuantity'
} as const

export type TournamentPayoutBracketScalarFieldEnum = (typeof TournamentPayoutBracketScalarFieldEnum)[keyof typeof TournamentPayoutBracketScalarFieldEnum]


export const TournamentBlindStructureSnapshotScalarFieldEnum = {
  id: 'id',
  name: 'name',
  description: 'description',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type TournamentBlindStructureSnapshotScalarFieldEnum = (typeof TournamentBlindStructureSnapshotScalarFieldEnum)[keyof typeof TournamentBlindStructureSnapshotScalarFieldEnum]


export const TournamentBlindLevelSnapshotScalarFieldEnum = {
  id: 'id',
  blindStructureId: 'blindStructureId',
  levelNumber: 'levelNumber',
  ante: 'ante',
  smallBlind: 'smallBlind',
  bigBlind: 'bigBlind',
  bringIn: 'bringIn',
  smallBet: 'smallBet',
  bigBet: 'bigBet'
} as const

export type TournamentBlindLevelSnapshotScalarFieldEnum = (typeof TournamentBlindLevelSnapshotScalarFieldEnum)[keyof typeof TournamentBlindLevelSnapshotScalarFieldEnum]


export const TournamentPayoutStructureSnapshotScalarFieldEnum = {
  id: 'id',
  name: 'name',
  description: 'description',
  type: 'type',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type TournamentPayoutStructureSnapshotScalarFieldEnum = (typeof TournamentPayoutStructureSnapshotScalarFieldEnum)[keyof typeof TournamentPayoutStructureSnapshotScalarFieldEnum]


export const TournamentPayoutBracketSnapshotScalarFieldEnum = {
  id: 'id',
  snapshotId: 'snapshotId',
  playersFrom: 'playersFrom',
  playersTo: 'playersTo',
  rankFrom: 'rankFrom',
  rankTo: 'rankTo',
  percentage: 'percentage',
  ticketTemplateId: 'ticketTemplateId',
  ticketQuantity: 'ticketQuantity'
} as const

export type TournamentPayoutBracketSnapshotScalarFieldEnum = (typeof TournamentPayoutBracketSnapshotScalarFieldEnum)[keyof typeof TournamentPayoutBracketSnapshotScalarFieldEnum]


export const TournamentTemplateScalarFieldEnum = {
  id: 'id',
  name: 'name',
  game: 'game',
  type: 'type',
  tableSize: 'tableSize',
  buyIn: 'buyIn',
  rake: 'rake',
  startingChips: 'startingChips',
  minPlayers: 'minPlayers',
  maxPlayers: 'maxPlayers',
  category: 'category',
  bettingStructure: 'bettingStructure',
  addonChips: 'addonChips',
  blindIntervalInMinutes: 'blindIntervalInMinutes',
  breakDurationInMinutes: 'breakDurationInMinutes',
  breakStartMinute: 'breakStartMinute',
  startingDisconnectionTimebankInSeconds: 'startingDisconnectionTimebankInSeconds',
  startingTimebankInSeconds: 'startingTimebankInSeconds',
  timebankRefillEveryLevels: 'timebankRefillEveryLevels',
  timebankRefillAmountInSeconds: 'timebankRefillAmountInSeconds',
  disconnectionTimebankRefillAmountInSeconds: 'disconnectionTimebankRefillAmountInSeconds',
  registrationOpenPeriodInMinutes: 'registrationOpenPeriodInMinutes',
  lateRegistrationPeriodInMinutes: 'lateRegistrationPeriodInMinutes',
  minimumTierRequired: 'minimumTierRequired',
  guaranteedPrizePool: 'guaranteedPrizePool',
  payoutDistributionPercentage: 'payoutDistributionPercentage',
  maxAddons: 'maxAddons',
  maxReentries: 'maxReentries',
  deletedAt: 'deletedAt',
  bountyAmount: 'bountyAmount',
  icon: 'icon',
  titleColor: 'titleColor',
  lobbyIcons: 'lobbyIcons',
  payoutStructureId: 'payoutStructureId',
  blindStructureId: 'blindStructureId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type TournamentTemplateScalarFieldEnum = (typeof TournamentTemplateScalarFieldEnum)[keyof typeof TournamentTemplateScalarFieldEnum]


export const TournamentRecurringScheduleScalarFieldEnum = {
  id: 'id',
  templateId: 'templateId',
  recurringType: 'recurringType',
  recurringFrequency: 'recurringFrequency',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type TournamentRecurringScheduleScalarFieldEnum = (typeof TournamentRecurringScheduleScalarFieldEnum)[keyof typeof TournamentRecurringScheduleScalarFieldEnum]


export const TournamentScalarFieldEnum = {
  id: 'id',
  templateId: 'templateId',
  name: 'name',
  game: 'game',
  type: 'type',
  tableSize: 'tableSize',
  buyIn: 'buyIn',
  rake: 'rake',
  minPlayers: 'minPlayers',
  maxPlayers: 'maxPlayers',
  recurringScheduleId: 'recurringScheduleId',
  contractAddress: 'contractAddress',
  category: 'category',
  bettingStructure: 'bettingStructure',
  startingChips: 'startingChips',
  addonChips: 'addonChips',
  guaranteedPrizePool: 'guaranteedPrizePool',
  payoutDistributionPercentage: 'payoutDistributionPercentage',
  prizePool: 'prizePool',
  maxReentries: 'maxReentries',
  maxAddons: 'maxAddons',
  bountyAmount: 'bountyAmount',
  timeoutInSeconds: 'timeoutInSeconds',
  startingDisconnectionTimebankInSeconds: 'startingDisconnectionTimebankInSeconds',
  startingTimebankInSeconds: 'startingTimebankInSeconds',
  timebankRefillEveryLevels: 'timebankRefillEveryLevels',
  timebankRefillAmountInSeconds: 'timebankRefillAmountInSeconds',
  disconnectionTimebankRefillAmountInSeconds: 'disconnectionTimebankRefillAmountInSeconds',
  blindIntervalInMinutes: 'blindIntervalInMinutes',
  breakDurationInMinutes: 'breakDurationInMinutes',
  breakStartMinute: 'breakStartMinute',
  blindStructureId: 'blindStructureId',
  payoutStructureId: 'payoutStructureId',
  currentLevel: 'currentLevel',
  registrationOpenTime: 'registrationOpenTime',
  startTime: 'startTime',
  endTime: 'endTime',
  lateRegistrationTime: 'lateRegistrationTime',
  handByHand: 'handByHand',
  status: 'status',
  isPublic: 'isPublic',
  minimumTierRequired: 'minimumTierRequired',
  url: 'url',
  queueUrl: 'queueUrl',
  topicArn: 'topicArn',
  timeLeftInLevel: 'timeLeftInLevel',
  levelEndAt: 'levelEndAt',
  breakEndAt: 'breakEndAt',
  skipBreaks: 'skipBreaks',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  finishedAt: 'finishedAt',
  deletedAt: 'deletedAt',
  cancellationReason: 'cancellationReason',
  entries: 'entries',
  playersRemaining: 'playersRemaining',
  icon: 'icon',
  titleColor: 'titleColor',
  lobbyIcons: 'lobbyIcons',
  parentTournamentId: 'parentTournamentId'
} as const

export type TournamentScalarFieldEnum = (typeof TournamentScalarFieldEnum)[keyof typeof TournamentScalarFieldEnum]


export const TournamentRegistrationScalarFieldEnum = {
  id: 'id',
  tournamentId: 'tournamentId',
  userId: 'userId',
  registeredAt: 'registeredAt',
  rebuysCount: 'rebuysCount',
  reentriesCount: 'reentriesCount',
  addonsCount: 'addonsCount',
  isEliminated: 'isEliminated',
  eliminationAt: 'eliminationAt',
  finalPosition: 'finalPosition',
  prizeAwarded: 'prizeAwarded',
  ticketId: 'ticketId'
} as const

export type TournamentRegistrationScalarFieldEnum = (typeof TournamentRegistrationScalarFieldEnum)[keyof typeof TournamentRegistrationScalarFieldEnum]


export const TournamentTableAssignmentScalarFieldEnum = {
  id: 'id',
  tournamentId: 'tournamentId',
  tableId: 'tableId',
  active: 'active',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type TournamentTableAssignmentScalarFieldEnum = (typeof TournamentTableAssignmentScalarFieldEnum)[keyof typeof TournamentTableAssignmentScalarFieldEnum]


export const TournamentEventScalarFieldEnum = {
  id: 'id',
  tournamentId: 'tournamentId',
  tableId: 'tableId',
  eventType: 'eventType',
  message: 'message',
  createdAt: 'createdAt',
  eventData: 'eventData'
} as const

export type TournamentEventScalarFieldEnum = (typeof TournamentEventScalarFieldEnum)[keyof typeof TournamentEventScalarFieldEnum]


export const TournamentRebuyAddonLogScalarFieldEnum = {
  id: 'id',
  tournamentId: 'tournamentId',
  userId: 'userId',
  type: 'type',
  amount: 'amount',
  chipStackAdded: 'chipStackAdded',
  createdAt: 'createdAt'
} as const

export type TournamentRebuyAddonLogScalarFieldEnum = (typeof TournamentRebuyAddonLogScalarFieldEnum)[keyof typeof TournamentRebuyAddonLogScalarFieldEnum]


export const TournamentPlayerMovementScalarFieldEnum = {
  id: 'id',
  tournamentId: 'tournamentId',
  userId: 'userId',
  fromTableId: 'fromTableId',
  toTableId: 'toTableId',
  fromSeat: 'fromSeat',
  toSeat: 'toSeat',
  createdAt: 'createdAt'
} as const

export type TournamentPlayerMovementScalarFieldEnum = (typeof TournamentPlayerMovementScalarFieldEnum)[keyof typeof TournamentPlayerMovementScalarFieldEnum]


export const TournamentPayoutScalarFieldEnum = {
  id: 'id',
  tournamentId: 'tournamentId',
  userId: 'userId',
  amount: 'amount',
  rank: 'rank',
  transactionId: 'transactionId',
  createdAt: 'createdAt',
  ticketId: 'ticketId'
} as const

export type TournamentPayoutScalarFieldEnum = (typeof TournamentPayoutScalarFieldEnum)[keyof typeof TournamentPayoutScalarFieldEnum]


export const TournamentDollarLedgerScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  amount: 'amount',
  type: 'type',
  referenceType: 'referenceType',
  referenceId: 'referenceId',
  tournamentId: 'tournamentId',
  transactionId: 'transactionId',
  balanceAfter: 'balanceAfter',
  note: 'note',
  createdAt: 'createdAt'
} as const

export type TournamentDollarLedgerScalarFieldEnum = (typeof TournamentDollarLedgerScalarFieldEnum)[keyof typeof TournamentDollarLedgerScalarFieldEnum]


export const TournamentRebalanceMetricsScalarFieldEnum = {
  id: 'id',
  tournamentId: 'tournamentId',
  requestsCreated: 'requestsCreated',
  requestsQueued: 'requestsQueued',
  requestsProcessed: 'requestsProcessed',
  requestsFailed: 'requestsFailed',
  requestsDeduped: 'requestsDeduped',
  movesExecuted: 'movesExecuted',
  tablesClosed: 'tablesClosed',
  handWaitTime: 'handWaitTime',
  processingTime: 'processingTime',
  activeHands: 'activeHands',
  completedHands: 'completedHands',
  stuckHands: 'stuckHands',
  forceCompletedHands: 'forceCompletedHands',
  events: 'events',
  finalPlayerCount: 'finalPlayerCount',
  totalDuration: 'totalDuration',
  avgPlayersPerTable: 'avgPlayersPerTable',
  tournamentStartedAt: 'tournamentStartedAt',
  tournamentEndedAt: 'tournamentEndedAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type TournamentRebalanceMetricsScalarFieldEnum = (typeof TournamentRebalanceMetricsScalarFieldEnum)[keyof typeof TournamentRebalanceMetricsScalarFieldEnum]


export const GlobalSettingsScalarFieldEnum = {
  key: 'key',
  value: 'value',
  type: 'type',
  category: 'category',
  description: 'description',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type GlobalSettingsScalarFieldEnum = (typeof GlobalSettingsScalarFieldEnum)[keyof typeof GlobalSettingsScalarFieldEnum]


export const TournamentSettingsScalarFieldEnum = {
  tournamentId: 'tournamentId',
  key: 'key',
  value: 'value',
  type: 'type',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type TournamentSettingsScalarFieldEnum = (typeof TournamentSettingsScalarFieldEnum)[keyof typeof TournamentSettingsScalarFieldEnum]


export const SortOrder = {
  asc: 'asc',
  desc: 'desc'
} as const

export type SortOrder = (typeof SortOrder)[keyof typeof SortOrder]


export const NullableJsonNullValueInput = {
  DbNull: 'DbNull',
  JsonNull: 'JsonNull'
} as const

export type NullableJsonNullValueInput = (typeof NullableJsonNullValueInput)[keyof typeof NullableJsonNullValueInput]


export const JsonNullValueInput = {
  JsonNull: 'JsonNull'
} as const

export type JsonNullValueInput = (typeof JsonNullValueInput)[keyof typeof JsonNullValueInput]


export const QueryMode = {
  default: 'default',
  insensitive: 'insensitive'
} as const

export type QueryMode = (typeof QueryMode)[keyof typeof QueryMode]


export const NullsOrder = {
  first: 'first',
  last: 'last'
} as const

export type NullsOrder = (typeof NullsOrder)[keyof typeof NullsOrder]


export const JsonNullValueFilter = {
  DbNull: 'DbNull',
  JsonNull: 'JsonNull',
  AnyNull: 'AnyNull'
} as const

export type JsonNullValueFilter = (typeof JsonNullValueFilter)[keyof typeof JsonNullValueFilter]

